import React from 'react';
import { useGetContentsByTagWebQuery } from '../../../features/contentsApiSlice';
import { useSelector } from 'react-redux';
import { selectCurrentLanguage } from '../../../features/langSlice';
import { ExpertDesc, PhilippBio1, PhilippBio2 } from '../../../Constants';
import { useTranslation } from 'react-i18next';
import CurvedArrow from '../../../assets/curved-arrow.png';
import { normalizeLanguageCode } from '../../../utils/language';
import PhilippPhoto from '../../../assets/partner/Philip.png';

const ExpertSection = () => {
  const { t } = useTranslation();
  const selectedLang = useSelector(selectCurrentLanguage);
  // data[6], data[7] are experts
  const { data: content } = useGetContentsByTagWebQuery({
    tag: 'home',
    lang: normalizeLanguageCode(selectedLang),
    skip: false,
  });

  const philippSrc = content?.data[6]?.picture
    ? process.env.REACT_APP_PUBLIC_URL + content.data[6].picture
    : PhilippPhoto;

  return (
    <div className="!t-relative t-flex t-flex-row t-items-start t-p-4 t-w-full !t-max-w-[400px] lg:!t-max-w-[450px] t-mx-auto">
      <div className="t-w-[60%] t-flex t-flex-col t-items-center t-gap-0">
        <img
          src={philippSrc}
          alt=""
          className="t-h-32 t-w-32 lg:t-h-40 lg:t-w-40"
        />
        <p className="!t-m-0 t-text-lg t-font-sans t-font-semibold t-text-center t-text-navy lg:t-mt-4">
          Philipp Pfeiffer
        </p>
        <p className="!t-m-0 t-font-sans t-text-base t-text-center t-text-navy/70">{t(PhilippBio1)}</p>
        <p className="!t-m-0 t-font-sans t-text-base t-text-center t-text-navy/70">{t(PhilippBio2)}</p>
      </div>
      <div className="!t-absolute !t-right-4 !t-top-4 !t-w-40">
        <p className="!t-m-0 !t-text-xl !t-leading-[20px]" style={{ fontFamily: "'Caveat', cursive" }}>
          {t(ExpertDesc)}
        </p>
        <img src={CurvedArrow} alt="" className="!t-w-12 !t-h-8" />
      </div>
    </div>
  );
};

const ExpertCard = ({ image, name, content }) => (
  <div className="t-flex t-flex-col t-items-center t-gap-2 t-justify-center">
    <img src={process.env.REACT_APP_PUBLIC_URL + image} alt="" className="t-h-32 t-w-32" />
    <p className="t-m-0 t-text-lg t-font-sans t-font-semibold t-text-center t-text-navy">{name}</p>
    <h5
      className="t-text-sm t-text-navy/70 t-font-sans t-font-bold t-text-center"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  </div>
);

export default ExpertSection;
